import computeDistance from '@/core/lib/utils/computeDistance/computeDistance';

export default computeDistance;
